import {
    GET_ACCIONISTA,
    GET_ADMINISTRADOR,
    GET_EMPLEADOS,
    GET_ERROR_ACCIONISTA,
    GET_ERROR_ADMINISTRADOR,
    GET_ERROR_EMPLEADOS,
    GET_ERROR_LEGALINFOBASIC,
    GET_LEGALINFOBASIC,
    LOADING_ACCIONISTA,
    LOADING_ADMINISTRADOR,
    LOADING_EMPLEADOS,
    LOADING_LEGALINFOBASIC,
    RESET_STATE_LEGALPERSON,
    RESET_SUCCESS_LEGALPERSON,
    LOADING_CONTRIB_IMPUESTOS,
    GET_CONTRIB_IMPUESTOS,
    GET_ERROR_CONTRIB_IMPUESTOS,
    GET_ACCIONISTA_SUPERCIAS,
    LOADING_ACCIONISTA_SUPERCIAS,
    GET_ERROR_ACCIONISTA_SUPERCIAS,
    GET_ADMINISTRADORES_SUPERCIAS,
    LOADING_ADMINISTRADORES_SUPERCIAS,
    GET_ERROR_ADMINISTRADORES_SUPERCIAS,
    GET_DEUDAS_FIRMES,
    LOADING_DEUDAS_FIRMES, GET_ERROR_DEUDAS_FIRMES
} from "../../actionsType/legal/legalActionType"


const INITIAL_STATE = {
    loading_legalInfo: false,
    error_legalInfo: null,
    success_legalInfo: null,
    loading_accionista: false,
    error_accionista: null,
    success_accionista: null,
    loading_administrador: false,
    error_administrador: null,
    success_administrador: null,
    loading_empleados: false,
    error_empleados: null,
    success_empleados: null,
    success_contrib_impuestos: null,
    loading_contrib_impuestos: false,
    error_contrib_impuestos: null,
    loading_accionista_supercias: false,
    error_accionista_supercias: null,
    success_accionista_supercias: null,
    loading_adm_supercias: false,
    error_adm_supercias: null,
    success_adm_supercias: null,
    loading_deudas_firmes: false,
    error_deudas_firmes: null,
    success_deudas_firmes: null
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESET_STATE_LEGALPERSON:
            return {
                ...state,
                loading_legalInfo: false,
                error_legalInfo: null,
                loading_accionista: false,
                error_accionista: null,
                loading_administrador: false,
                error_administrador: null,
                loading_empleados: false,
                error_empleados: null,
                loading_contrib_impuestos: false,
                error_contrib_impuestos: null,
                loading_accionista_supercias: false,
                error_accionista_supercias: null,
                loading_adm_supercias: false,
                error_adm_supercias: null,
                loading_deudas_firmes: false,
                error_deudas_firmes: null
            }
        case RESET_SUCCESS_LEGALPERSON:
            return {
                ...state,
                success_legalInfo: null,
                success_accionista: null,
                success_administrador: null,
                success_empleados: null,
                success_contrib_impuestos: null,
                success_accionista_supercias: null,
                success_adm_supercias: null,
                sucess_deudas_firmes: null
            }
        case GET_LEGALINFOBASIC:
            return {
                ...state,
                loading_legalInfo: false,
                error_legalInfo: null,
                success_legalInfo: action.payload
            }
        case LOADING_LEGALINFOBASIC:
            return {
                ...state,
                loading_legalInfo: true,
                error_legalInfo: null,
                success_legalInfo: null
            }
        case GET_ERROR_LEGALINFOBASIC:
            return {
                ...state,
                error_legalInfo: action.payload,
                loading_legalInfo: false
            }
        case GET_ACCIONISTA:
            return {
                ...state,
                loading_accionista: false,
                error_accionista: null,
                success_accionista: action.payload
            }
        case LOADING_ACCIONISTA:
            return {
                ...state,
                loading_accionista: true,
                error_accionista: null,
                success_accionista: null
            }
        case GET_ERROR_ACCIONISTA:
            return {
                ...state,
                error_accionista: action.payload,
                loading_accionista: false
            }

        case GET_ADMINISTRADOR:
            return {
                ...state,
                loading_administrador: false,
                error_administrador: null,
                success_administrador: action.payload
            }
        case LOADING_ADMINISTRADOR:
            return {
                ...state,
                loading_administrador: true,
                error_administrador: null,
                success_administrador: null
            }
        case GET_ERROR_ADMINISTRADOR:
            return {
                ...state,
                error_administrador: action.payload,
                loading_administrador: false
            }
        case GET_EMPLEADOS:
            return {
                ...state,
                loading_empleados: false,
                error_empleados: null,
                success_empleados: action.payload
            }
        case LOADING_EMPLEADOS:
            return {
                ...state,
                loading_empleados: true,
                error_empleados: null,
                success_empleados: null
            }
        case GET_ERROR_EMPLEADOS:
            return {
                ...state,
                error_empleados: action.payload,
                loading_empleados: false
            }

        case GET_CONTRIB_IMPUESTOS:
            return {
                ...state,
                loading_contrib_impuestos: false,
                error_contrib_impuestos: null,
                success_contrib_impuestos: action.payload
            }
        case LOADING_CONTRIB_IMPUESTOS:
            return {
                ...state,
                loading_contrib_impuestos: true,
                error_contrib_impuestos: null,
                success_contrib_impuestos: null
            }
        case GET_ERROR_CONTRIB_IMPUESTOS:
            return {
                ...state,
                error_contrib_impuestos: action.payload,
                loading_contrib_impuestos: false
            }
        case GET_ACCIONISTA_SUPERCIAS:
            return {
                ...state,
                loading_accionista_supercias: false,
                error_accionista_supercias: null,
                success_accionista_supercias: action.payload
            }
        case LOADING_ACCIONISTA_SUPERCIAS:
            return {
                ...state,
                loading_accionista_supercias: true,
                error_accionista_supercias: null,
                success_accionista_supercias: null
            }
        case GET_ERROR_ACCIONISTA_SUPERCIAS:
            return {
                ...state,
                error_accionista_supercias: action.payload,
                loading_accionista_supercias: false
            }
        case GET_ADMINISTRADORES_SUPERCIAS:
            return {
                ...state,
                loading_adm_supercias: false,
                error_adm_supercias: null,
                success_adm_supercias: action.payload
            }
        case LOADING_ADMINISTRADORES_SUPERCIAS:
            return {
                ...state,
                loading_adm_supercias: true,
                error_adm_supercias: null,
                success_adm_supercias: null
            }
        case GET_ERROR_ADMINISTRADORES_SUPERCIAS:
            return {
                ...state,
                error_adm_supercias: action.payload,
                loading_adm_supercias: false
            }
        case GET_DEUDAS_FIRMES:
            return {
                ...state,
                loading_deudas_firmes: false,
                error_deudas_firmes: null,
                success_deudas_firmes: action.payload
            }
        case LOADING_DEUDAS_FIRMES:
            return {
                ...state,
                loading_deudas_firmes: true,
                error_deudas_firmes: null,
                success_deudas_firmes: null
            }
        case GET_ERROR_DEUDAS_FIRMES:
            return {
                ...state,
                error_deudas_firmes: action.payload,
                loading_deudas_firmes: false
            }
        default:
            return state
    }
}
